import React, { Fragment } from 'react'
import ShowCase from '../../Components/UI/showCase'
import HomeCards from '../../Components/UI/homeCards';

const Home = () => {
    return ( 
        <Fragment>
            <ShowCase />
            <HomeCards />
        </Fragment>
     );
}
 
export default Home;